export const CatalogosSection = () => {
  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          
          {/* Catálogo Aves y Roedores */}
          <div className="relative rounded-3xl overflow-hidden
            
         bg-[url('/images/catalogo-aves-roedores-00.jpg')] bg-cover bg-center bg-no-repeat
         max-w-128 max-h-128

         ">
            <div className="p-8 h-128 flex flex-col">
              <div className="mb-6">
                <h2 className="text-2xl text-black mb-1">Catálogo</h2>
                <h3 className="text-2xl font-bold text-black">Aves y Roedores</h3>
              </div>
              
              {/* Imagen del catálogo */}
                <div className="h-96 w-96 bg-transparent"/>
              
              {/* Botón Descargar */}
              <div className="mt-6">
                <a
                  href="https://cdn.jaradpetfood.com/CATALOGO_JARAD_2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 transition-colors inline-block"
                >
                  Ver Catálogo
                </a>
              </div>
            </div>
          </div>

          {/* Catálogo Perros y Gatos */}
          <div className="relative rounded-3xl overflow-hidden

         bg-[url('/images/catalogo-perros-gatos00.jpg')] bg-cover bg-center bg-no-repeat
         max-w-128 max-h-128

         ">
            <div className="p-8 h-128 flex flex-col">
              <div className="mb-6">
                <h2 className="text-2xl text-black mb-1">Catálogo</h2>
                <h3 className="text-2xl font-bold text-black">Perros y Gatos</h3>
              </div>

              {/* Imagen del catálogo */}
                <div className="h-96 w-96 bg-transparent"/>

              {/* Botón Descargar */}
              <div className="mt-6">
                <a
                  href="https://cdn.jaradpetfood.com/JARAD-PERROS-Y-GATOS-2025.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-black text-white px-6 py-3 rounded-full font-medium hover:bg-gray-800 transition-colors inline-block"
                >
                  Ver Catálogo
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CatalogosSection; 